import Context from '@alltrails/core/types/Context';

const getHasLegacyPortalAccess = (context: Context) => {
  const legacyGroups = (context as Context & { groups?: any[] }).groups;

  return Boolean(legacyGroups?.length);
};

export default getHasLegacyPortalAccess;
